// extracted by extract-css-chunks-webpack-plugin
module.exports = {"flowCardContent":"_1XvVNp","image":"fsbJNY","button":"yPV0Wp","slide_0":"_1rSpW0","flowCardTextColor":"_2VpKvD","flowCardHeading":"_1jxE9h","flowCardParagraph":"_2LDL0o"};